/**
 * utils/paths.ts
 *
 * Checks for return paths passed in the address (`?back=`, `?from=`).
 */

/** A path on this site: not `//host`, `/\host`, or a full URL. */
export function isInAppPath(path: string): boolean {
  if (!path.startsWith('/')) return false;
  try {
    const origin = 'https://app.invalid';
    return new URL(path, origin).origin === origin;
  } catch {
    return false;
  }
}
